// Deck's Recast adapter. Browser and Worker use the same Holt planner but load WASM differently.
import { init, NavMeshQuery, Raw, Detour } from 'recast-navigation';
import { createTiledBuilder } from './recast-builder.js';
import { configureNavigation, NavigationUnavailable, NavigationCancelled, NavigationInvalidated, CLEAR, sweepClear, boxFits, findPath, nearestTile } from '../../../packages/holt-navigation/src/navigation.js';
export { NavigationUnavailable, NavigationCancelled, NavigationInvalidated, CLEAR, sweepClear, boxFits, findPath, nearestTile };
export { escapeClear, recoveryPositions } from '../../../packages/holt-navigation/src/geometry.js';
let state = 'idle', starting = null;
export const navigationState = () => state;
/** The optional implementation instantiates a precompiled module on workerd. */
export function initializeNavigation(implementation) {
  if (starting) return starting;
  state = 'loading';
  starting = Promise.resolve().then(() => init(implementation)).then(() => {
    configureNavigation({ NavMeshQuery, createTiledBuilder, destroy: (o) => Raw.destroy(o),
      fatalStatusMask: Detour.DT_OUT_OF_NODES | Detour.DT_BUFFER_TOO_SMALL | Detour.DT_OUT_OF_MEMORY });
    state = 'ready'; return true;
  }).catch((error) => {
    state = 'failed'; console.error('Holt navigation initialization failed:', error); return false;
  });
  return starting;
}
if (typeof window !== 'undefined' && typeof document !== 'undefined') void initializeNavigation();
